import React from 'react';
import { commonStyles } from 'utils/designSystem';

const Select = ({ children, style = {}, ...props }) => {
  return (
    <select
      style={{
        ...commonStyles.select,
        ...style
      }}
      {...props}
    >
      {children}
    </select>
  );
};

export default Select;